export class UserInfo {
    name = '';
    cuit = '';
    hasRepresantos = false;
    hasFiscalizaciones= false;
    isProcurador = false;
    isMartillero = false;
    isCorredor = false;
}
